import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    /**
     * @description 退换货服务单列表
     */
    refunds: function refunds() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                return _context.abrupt("return", request({
                  url: '/refund/refunds',
                  data: data
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 退换货详情
     * @param {Object} data
     */
    refundDetails: function refundDetails() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/refund/refundDetails',
        data: data
      });
    },

    /**
     * @description 审核退款
     * @param {Object} data
     */
    auditRefund: function auditRefund() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/refund/auditRefund',
        data: data
      });
    },

    /**
     * @description 确认收货
     * @param {Object} data
     */
    checked: function checked() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/refund/checked',
        data: data
      });
    },

    /**
     * @description 新货出库
     * @param {Object} data
     */
    refund_delivery: function refund_delivery() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/refund/delivery',
        data: data
      });
    },

    /**
     * @description 修改客户收货地址
     * @param {Object} data
     */
    updateConsignee2: function updateConsignee2() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/refund/updateConsignee',
        data: data
      });
    },

    /**
     * @description 协商记录
     * @param {Object} data
     */
    refundConsults: function refundConsults() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/refund/refundConsults',
        data: data
      });
    }
  };
});